module.exports = __webpack_public_path__ + "static/media/bannermobile.c5230454.png";